export default __webpack_public_path__ + "static/media/spin-the-wheel.e7f9b45a.svg";